import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { Box, CircularProgress } from "@mui/material";
import { Suspense } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useBrowserBack } from "src/shared/context/BrowserBack";
import { useAuth } from "src/shared/context/useAuth";

function RouteProtector({
  children,
  allowedUsers,
}: {
  children: ReactJSXElement;
  allowedUsers: (
    | "isChamber"
    | "isBusiness"
    | "isNonGemiUser"
    | "isOrgAdmin"
    | "isSystemAdmin"
    | "isCashier"
    | "isRegion"
    | "isGGEAdmin"
    | "isGGE"
    | "isSampleInitiator"
    | "isChamberOnly"
    | "isSupervisorAssigner"
    | "isSupervisorAssignee"
  )[];
}) {
  const { userInfo, isLoading } = useAuth();
  const location = useLocation();
  const { previousPage } = useBrowserBack();
  const navigate = useNavigate();
  const { userHomePath } = useAuth();

  if (isLoading) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  let found = false;
  for (const userType of allowedUsers) {
    if (userInfo && userInfo[userType]) {
      found = true;
      return (
        <Suspense
          fallback={
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          }
        >
          {children}
        </Suspense>
      );
    }
  }
  if (!found) {
    if (
      location.pathname.includes("followCompany/searchCompanyToFollow") &&
      !previousPage &&
      new URL(document.referrer).origin !== window.location.origin
    )
      sessionStorage.setItem(
        "attemptedRoute",
        location.pathname + location.search,
      );

    navigate(userHomePath);
  }
  navigate(userHomePath);
}

export default RouteProtector;
